import { render, staticRenderFns } from "./AffiliateLinkForm.vue?vue&type=template&id=32d77200&"
import script from "./AffiliateLinkForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports